module.exports = __webpack_public_path__ + "static/media/Video_Allow_Instruction_22.096d48bf.jpg";